export default "__VITE_ASSET__be928bc6__"